module.exports = __webpack_public_path__ + "static/img/lifestyle_01.e684e387.jpg";